import { createSelector } from "@reduxjs/toolkit";
import { StoreState } from "../../store";

const selector = (state: StoreState) => state.tenant;

export const tenantSelectors = {
  tenants: createSelector(selector, (state) => state.tenants),
};
